module.exports = __webpack_public_path__ + "static/media/socials-facebook-gray.95de3da6.svg";